/* eslint-disable no-magic-numbers */

import { SymbolLayerSpecification } from 'mapbox-gl';

import NextImage from 'next/image';
import placeholder from '../assets/img_trans.gif';
import spriteHybridJson from '../assets/sprite_hybrid.json';
import spriteHybridImage from '../assets/sprite_hybrid.png';
import spriteTerrainJson from '../assets/sprite_terrain.json';
import spriteTerrainImage from '../assets/sprite_terrain.png';
import { DEFAULT_MAP_STYLE, MapStyle } from '../constants/constants';

// It is ok to avoid spriteTerrainJson here;
// icons uploaded to Mapbox Studio can differ based on the style but their names have to match
export type MapIconName = keyof typeof spriteHybridJson;
export type SymbolLayerWithMapIcon = SymbolLayerSpecification & {
  layout: SymbolLayerSpecification['layout'] & {
    'icon-image': MapIconName;
  };
};

export type MapIconScale = 0.8 | 0.9 | 1 | 1.1 | 1.2 | 1.3 | 1.4 | 1.5 | 1.6 | 1.7 | 1.8 | 1.9 | 2;
export const MapIconDefaultScale = 0.8;

interface IProps {
  alt: string;
  name: MapIconName;
  scale?: MapIconScale;
  className?: string;
  mapStyle?: MapStyle;
}

type SpriteIconDefinition = Record<
  string,
  {
    width: number;
    height: number;
    x: number;
    y: number;
    pixelRatio: number;
    visible: boolean;
  }
>;

export const MapIcon = ({
  name,
  alt,
  scale = 1,
  className,
  mapStyle = DEFAULT_MAP_STYLE,
}: IProps) => {
  const spriteJson: SpriteIconDefinition =
    mapStyle === 'hybrid' ? spriteHybridJson : spriteTerrainJson;
  const spriteImage = mapStyle === 'hybrid' ? spriteHybridImage.src : spriteTerrainImage.src;

  const sprite = spriteJson[name]!;

  return (
    <div
      style={{
        width: (sprite.width * scale) / sprite.pixelRatio,
        height: (sprite.height * scale) / sprite.pixelRatio,
      }}
    >
      <NextImage
        alt={alt}
        src={placeholder.src}
        className={className}
        unoptimized
        width={1}
        height={1}
        style={{
          width: sprite.width,
          height: sprite.height,
          backgroundImage: `url(${spriteImage})`,
          backgroundPosition: `-${sprite.x}px -${sprite.y}px`,
          transform: `scale(${scale / sprite.pixelRatio})`,
          transformOrigin: `top left`,
          maxWidth: `none`,
        }}
      />
    </div>
  );
};
